var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1395_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43946 8.5C9.78692 8.5 11.6895 6.59746 11.6895 4.25C11.6895 1.90254 9.78692 0 7.43946 0C5.09199 0 3.18945 1.90254 3.18945 4.25C3.18945 6.59746 5.09199 8.5 7.43946 8.5ZM10.4145 9.5625H9.85996C9.12285 9.90117 8.30274 10.0938 7.43946 10.0938C6.57617 10.0938 5.75938 9.90117 5.01895 9.5625H4.46445C2.00078 9.5625 0.00195312 11.5613 0.00195312 14.025V15.4062C0.00195312 16.2861 0.715821 17 1.5957 17H13.2832C14.1631 17 14.877 16.2861 14.877 15.4062V14.025C14.877 11.5613 12.8781 9.5625 10.4145 9.5625Z",
    fill: "url(#paint0_linear_1395_116)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_116",
    x1: 0.574069,
    y1: 2.83334,
    x2: 15.1233,
    y2: 3.62429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6535E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E33E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1395_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8784,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ea6314240ff14599da4635a6e884e126.svg";
export { ForwardRef as ReactComponent };